import { Overline } from "./Overline";

export const AimaMeaning = ({ testId = "aima-meaning" }) => {
  return (
    <section
      data-testid={testId}
      className="py-20 md:py-28 bg-[#f7f4ee]/60 border-y border-[#ede8df]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="arch-image aspect-[4/5] bg-[#cbdad6]">
            <img
              src="/brand/lara-flowers.jpg"
              alt="Lara amongst dahlias in golden light"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
        <div className="lg:col-span-7 order-1 lg:order-2">
          <Overline>The name</Overline>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.06] font-normal text-[#333] mt-5">
            What does
            <br />
            <span className="italic">Aima mean?</span>
          </h2>
          <div className="mt-8 space-y-5 text-base md:text-lg text-[#3d3d3d] font-normal leading-relaxed">
            <p>
              Aima is a name inspired by its meanings across cultures and
              languages. Take the <strong className="text-[#333] font-semibold">Greek</strong> for blood, <em>aíma</em> - αίμα - the
              sacred life force of the womb from which life is created.
              Blood, so often associated with harm or aversion, is something
              women are intimately connected to from puberty to menopause.
              It contains vital health signals and is now being studied for
              its healing stem cells.
            </p>
            <p>
              In <strong className="text-[#333] font-semibold">Sanskrit</strong>, <em>Aiṃ</em> - ऐं - has meanings ranging from the
              divine wisdom of nature to a mantra for expression and
              communication, historically denied to women. In <strong className="text-[#333] font-semibold">Arabic</strong>,{" "}
              <em>aima</em> carries meanings of noble, blessed, leader, and
              source of life. In <strong className="text-[#333] font-semibold">Nigerian</strong> cultures, it is associated with
              life itself. In <strong className="text-[#333] font-semibold">Spanish</strong>, <em>alma</em>, a paronym, means soul,
              echoing mind-body integration.
            </p>
            <p>
              The <strong className="text-[#333] font-semibold">Hebrew</strong> <em>Ima</em> (אמא) means mother. Whether or not a
              woman bears children, she belongs to the collective feminine
              from which life emerges. Every human is born of a woman, though
              women have long been repressed by the very societies they
              sustain.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
